import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=f842b4c6&"
import script from "./LogoutView.vue?vue&type=script&lang=js&"
export * from "./LogoutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports